export default __webpack_public_path__ + "ceb376c9aa48f7ca849f7b21e4d37522.svg";